module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAJzCAMAAAD5volYAAAAPFBMVEX/sVL/rU3/q0v/r0//t1n/tFX/3YP/2oD/03f/u1z/yGz/xWj/wmX/1nv/0HT/zXH/2H3/vmD/wGL/y2/MqE4aAAAAOklEQVR4XrXBBwHAIAADMP7f9+91FqAtiUmiWf5eeFAL/CRfyz9go3bigL8TH3AVDqJRVMdDLdHt+gPfHBVXumZ22AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/extend-major-bg.png
// module id = 528
// module chunks = 0